import { TAXPAYER_ID_NUMBER } from '@/common/constants/validations';

// /^[a-zA-Zа-яёА-ЯЁ]+$/u

export const phoneValidation = (value) => !value || value.match(/\d+/g)?.join([]).length === 11;

export const firstnameValidation = (value) => {
  if (!value) return true;
  return /^[а-яёА-ЯЁ\s]+$/u.test(value);
};
export const lastnameValidation = (value) => {
  if (!value) return true;
  return /^[а-яёА-ЯЁ\s]+$/u.test(value);
};

// ИНН необязателен; если указан — ровно 12 символов (уникальность проверяет сервер и возвращает ошибку в поле).
export const innValidation = (value) => !value || String(value).length === TAXPAYER_ID_NUMBER.MAX_LENGTH;

export const startSpacesValidation = (value) => !/^\s/.test(value);

export const telegramUsernameValidation = (value) => {
  if (!value) return true;
  return /^@[a-zA-Z][a-zA-Z0-9_]{4,31}$/.test(value);
};
export const ImageValidators = {
  maxSize: (maxMB) => (value) => {
      if (!value || !(value instanceof File)) return true;
      return value.size <= maxMB * 1024 * 1024;
    },
  format: (formatsAllowed) => (value) => {
      if (!value || !(value instanceof File)) return true;
      const ext = value.name.split('.').pop().toLowerCase();
      const mime = value.type.split('/')[1]?.toLowerCase();
      return formatsAllowed.includes(ext) || formatsAllowed.includes(mime);
    }
};
export const customCardValidators = {
  maxSize: (maxMB) => (value) => {
    if (!value || !(value instanceof File)) return true;
    return value.size <= maxMB * 1024 * 1024;
  },
  format: (formatsAllowed) => (value) => {
    if (!Array.isArray(value) || value.length < 3) {
      return false;
    }
    return value.every((card) => {
      if (!card || !card.image || !(card.image instanceof File)) {
        return false;
      }
      const ext = card.image.name.split('.').pop().toLowerCase();
      const mime = card.image.type.split('/')[1]?.toLowerCase();

      return formatsAllowed.includes(ext) || formatsAllowed.includes(mime);
    });
  },
  countImage: () => (value) => {
    if (!value) return false;
    if (!value || !(Array.isArray(value) && value.length >= 3)) {
      return false;
    }
      return true;
  },
  requiredDescription: () => (value) => {
    if (!value) return false;
    return value.every((card) => (card.description.length > 10 && card.description.length <= 2000));
  },
  required: () => (value) => {
    if (!value || !(Array.isArray(value) && value.length >= 3)) return false;
    return true;
  },
  validatorLinks: () => (value) => {
    if (!value) return true;

    const protocol = '^(https?:\\/\\/)?';
    const domain = '([\\da-z.-]+)\\.';
    const tld = '([a-z.]{2,6})';
    const path = '([\\/\\w .-]*)'; // Путь (опционально)
    const query = '(\\?[\\w=&%#+.-]*)?'; // Query параметры (опционально)
    const end = '\\/?$';

    const urlPattern = new RegExp(
      protocol + domain + tld + path + query + end,
      'i'
    );

    return urlPattern.test(value) || false;
  }
};
